import React from 'react';
import { Box } from '@mui/material';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';
import { ArrowBackRounded as ArrowBackIcon } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';

const VoiceResultHeader = ({ title, onBack, hasBack = true }) => {
  const { t } = useTranslation();

  return (
    <Box
      className="voice-list-container-result-header"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        marginBottom: '8px',
      }}
    >
      {hasBack && (
        <ArrowBackIcon
          sx={{
            color: COLOR.indigo[64],
            fontSize: 24,
            padding: '4px',
            cursor: 'pointer',
          }}
          onClick={onBack}
        />
      )}
      <Typography variant="body-20-bold" color={COLOR.darkGray}>
        {t(title)}
      </Typography>
    </Box>
  );
};

export default VoiceResultHeader;
